import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-solid-down",
  "use": "icon-arrow-solid-down-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-solid-down\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M11.837 6c.256 0 .399.224.24.377l-4.265 4.106a.371.371 0 0 1-.48 0L3.067 6.377C2.907 6.224 3.05 6 3.307 6h8.53z\" fill=\"#D91D22\" />\n        <path d=\"M0 0h16v16H0z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol